const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  tagsView: state => state.settings.tagsView,
  fixedHeader: state => state.settings.fixedHeader,
  cachedViews: state => state.tagsView.cachedViews,
  // token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  errorLogs: state => state.errorLog.logs,

  // login
  token: state => state.login.token,
  // FIXME: 后续移除
  authRoutes: state => state.login.authRoutes,
  routes: state => state.login.routes,
  jurisdiction: state => state.login.jurisdiction,
  addonPermissions: state => state.login.addonPermissions,
  user: state => state.login.user,
  book: state => state.login.book,
  bookInfo: state => state.login.bookInfo,
  siteName: state => state.login.siteName,
  searchParams: state => state.login.searchParams,
  activeMenu: state => state.login.activeMenu,
  addonCenter: state => state.login.addonCenter,
  isView: state => state.updateView.isView,
  userList: state => state.userList.userList,
  allCompany: state => state.login.allCompany
}
export default getters
